import postOauthFormEncoded from '@gef-ui/middleware-api/auth/oauth2/postOAuthFormEncodedFacade';
import { MIDDLEWARE_NAME as OAUTH2_MIDDLEWARE_NAME } from '@gef-ui/middleware-api/middleware/oauth2/constants';
import { getAccessToken, getRefreshToken } from '@gef-ui/redux-common/selectors/appContext';
import { REVOKE_URL, TOKEN_HINT_TYPE, requestUuids } from '../../constants';
import { getClientIdAndRedirectUri } from '../../selectors';
const revokeToken = (token, tokenHint)=>async (dispatch, getState)=>{
        const { clientId, redirectUri } = getClientIdAndRedirectUri(getState());
        await dispatch(postOauthFormEncoded({
            endpoint: ({ urls })=>`${urls.token}${REVOKE_URL}`,
            body: {
                token,
                token_type_hint: tokenHint,
                client_id: clientId,
                redirect_uri: redirectUri
            },
            middlewares: {
                [OAUTH2_MIDDLEWARE_NAME]: {
                    skip: true
                }
            },
            meta: {
                requestUuid: `${requestUuids.revokeAuthorizationTokens}_${tokenHint}`
            }
        }));
    };
/**
 * Handles standard oauth2 revoke flow. Revokes each of available authorization tokens
 *
 * @documented
 * @category Action
 * @example
 *
 * 	dispatch(revokeAuthorizationTokens);
 *
 */ export default (async (dispatch, getState)=>{
    const state = getState();
    const refreshToken = getRefreshToken(state);
    const accessToken = getAccessToken(state);
    if (refreshToken) {
        await dispatch(revokeToken(refreshToken, TOKEN_HINT_TYPE.refreshToken));
    }
    if (accessToken) {
        await dispatch(revokeToken(accessToken, TOKEN_HINT_TYPE.accessToken));
    }
});
